import React from 'react';

import DoneIcon from 'material-ui/svg-icons/action/done';

import { TextInput, SelectInputFromData } from 'components/input';
import { SimpleForm } from 'components/form';

import SubsManage from './SubsManage';

import {
    DisabledExtendInputOptions,
    ExtendInputOptions,
} from './utils'


export const SubsShopRevoke = (props) => (
    <SubsManage {...props}>
        <SimpleForm submitButtonIcon={<DoneIcon/>} submitButtonLabel="Submit">
            <TextInput options={DisabledExtendInputOptions} label="Owner Shop ID" source="id"/>
            <SelectInputFromData
                label="Active Shops"
                source="shop_id_to_revoke"
                choiceSource="active_shop_choices"
                options={ExtendInputOptions}
            />
        </SimpleForm>
    </SubsManage>
);


// WEBPACK FOOTER //
// ./src/routes/subscription/SubsShopRevoke.js